<div class="cs-indicators">
  <div class="row mr-0 ml-0">
  
    <div class="cs-indicators-data" *ngFor="let indicator of data?.data">
        <cs-indicator [dataSource]="indicator" [dataAnnotation]="data.dataAnnotation"></cs-indicator>
      </div>

  </div>
</div>